export default {
  props: [
    'id',
    'name',
    'label',
    'getValue',
    'value',
    'error',
    'validator',
    'required',
    'options',
    'hasPlaceholder',
  ],
  data: function () {
    const data = {
      inputValue: '',
      inputOptions: [],
      isValid: true,
      isActive: false,
      showErrorMessage: false,
    };
    if (this.options) {
      if (typeof this.options === 'function') {
        data.inputOptions = this.options().map((opt) => {
          if (typeof opt !== 'undefined' && typeof opt.value === 'undefined') {
            return {
              value: opt,
              label: opt,
            };
          }
          return opt;
        });
      }
      if (Array.isArray(this.options)) {
        data.inputOptions = this.options.map((opt) => {
          if (typeof opt !== 'undefined' && typeof opt.value === 'undefined') {
            return {
              value: opt,
              label: opt,
            };
          }
          return opt;
        });
      }
    }
    if (
      this.getValue &&
      this.getValue.bind !== 'undefined' &&
      '' + this.getValue(this.name)
    ) {
      data.inputValue = this.getValue(this.name);
    } else if (data.inputOptions.length) {
      if (this.hasPlaceholder) {
        data.inputValue = 'placeholder';
      } else {
        data.inputValue = data.inputOptions[0].value;
      }
    }
    return data;
  },
  watch: {
    inputValue: function () {
      this.$emit('change', {
        value: this.inputValue,
        name: this.name,
      });
    },
    options: function () {
      if (this.options) {
        if (typeof this.options === 'function') {
          this.inputOptions = this.options().map((opt) => {
            if (
              typeof opt !== 'undefined' &&
              typeof opt.value === 'undefined'
            ) {
              return {
                value: opt,
                label: opt,
              };
            }
            return opt;
          });
        }
        if (Array.isArray(this.options)) {
          this.inputOptions = this.options.map((opt) => {
            if (
              typeof opt !== 'undefined' &&
              typeof opt.value === 'undefined'
            ) {
              return {
                value: opt,
                label: opt,
              };
            }
            return opt;
          });
        }
      }
      if (
        this.inputOptions &&
        this.inputValue &&
        this.inputValue !== 'placeholder'
      ) {
        const oldIndex = this.inputOptions.findIndex(
          (option) => option.value === this.inputValue,
        );
        if (oldIndex === -1) {
          this.inputValue =
            this.inputOptions[this.inputOptions.length - 1].value;
        }
      }
    },
  },
  mounted: function () {
    this.$emit('change', {
      value: this.inputValue,
      name: this.name,
    });
  },
  methods: {
    validate() {
      if (this.validator) {
        this.isValid = this.validator(this.inputValue);
      } else if (this.required && !('' + this.inputValue)) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
      return this.isValid;
    },
    setActive() {
      this.isActive = true;
    },
    unsetActive() {
      if (!this.inputValue || this.inputValue === 'placeholder')
        this.isActive = false;
    },
  },
  computed: {},
  template: `
  <div :class="[(!isValid)?'form-row__error': '']">
    <div class="select-input__wrap">
      <div class="select-input__el-wrap">
        <select v-on:blur="unsetActive" v-on:focus="setActive" :name="name" class="select-input__el p2" v-model="inputValue">
          <template v-if="inputOptions.length && hasPlaceholder">
            <option value="placeholder" selected disabled></option>

            <option
              v-for="(option, index) in inputOptions"
              :value="option.value">
              {{option.label}}
            </option>
          </template>

          <template v-else-if="inputOptions.length">
            <option
              v-for="(option, index) in inputOptions"
              :value="option.value"
              :selected="(inputValue === option.value)">
              {{option.label}}
            </option>
          </template>
          <template v-else>
            <option value="placeholder" selected disabled></option>
            <slot></slot>
          </template>
        </select>
        <i class="select-input__icon"></i>

        <label v-if="label" class="select-input__label" :class="[ isActive ? 'is-active' : '',  !isValid && isActive ? 'red' : '' ]" v-text="label"></label>
      </div>
    </div>
    <transition name="error-fade">
      <p v-if="!isValid" class="f2 form-row__error__text-error red">{{error}}</p>
    </transition>
  </div>`,
};
